import { render, staticRenderFns } from "./ask-go-on.vue?vue&type=template&id=c68cca62"
import script from "./ask-go-on.vue?vue&type=script&lang=ts"
export * from "./ask-go-on.vue?vue&type=script&lang=ts"
import style0 from "./ask-go-on.vue?vue&type=style&index=0&id=c68cca62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports